import Footer from "../Footer";
import Header from "../Header";
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';
import React from 'react';

function AudioTranscribeDocs() {
    return (
        <>
        <div className="container-fluid px-5 py-2"> 
            <Header  />
        </div>
            <div className="container">
                <main className="row">
                    <div class="flex-shrink-0 p-3 col-1" style={{ width: "280px" }}>
                        <a href="#" class="d-flex align-items-center pb-3 mb-3 link-body-emphasis text-decoration-none border-bottom">
                            <span class="fs-5 fw-semibold">Developer Documentation</span>
                        </a>

                        <ul class="list-unstyled ps-0">
                            <li class="mb-1">
                                <button
                                    class="btn btn-toggle d-inline-flex align-items-center rounded border-0"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#home-collapse"
                                    aria-expanded="true"
                                >
                                    Fast Transcription
                                </button>

                                <div class="collapse show" id="home-collapse">
                                    <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                                        <li>
                                            <a
                                                href="#fast-transcription-overview"
                                                class="link-body-emphasis d-inline-flex text-decoration-none rounded"
                                            >
                                                Overview
                                            </a>
                                        </li>

                                        <li>
                                            <a
                                                href="#fast-transcription-endpoint"
                                                class="link-body-emphasis d-inline-flex text-decoration-none rounded"
                                            >
                                                Endpoint
                                            </a>
                                        </li>

                                        <li>
                                            <a
                                                href="#fast-transcription-response"
                                                class="link-body-emphasis d-inline-flex text-decoration-none rounded"
                                            >
                                                Response
                                            </a>
                                        </li>

                                        <li>
                                            <a
                                                href="#fast-transcription-technicals"
                                                class="link-body-emphasis d-inline-flex text-decoration-none rounded"
                                            >
                                                Technical Specifications
                                            </a>
                                        </li>

                                        <li>
                                            <a
                                                href="#fast-transcription-errors"
                                                class="link-body-emphasis d-inline-flex text-decoration-none rounded"
                                            >
                                                Error Code
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li class="border-top my-3"></li>

                            {/* ACK DOCUMENTATION */}
                            <li class="mb-1">
                                <button
                                    class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#ack-collapse"
                                    aria-expanded="false"
                                >
                                    Transcription ACK
                                </button>

                                <div class="collapse" id="ack-collapse">
                                    <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                                        <li>
                                            <a
                                                href="#transcription-ack-overview"
                                                class="link-body-emphasis d-inline-flex text-decoration-none rounded"
                                            >
                                                Overview
                                            </a>
                                        </li>

                                        <li>
                                            <a
                                                href="#transcription-ack-endpoint"
                                                class="link-body-emphasis d-inline-flex text-decoration-none rounded"
                                            >
                                                Endpoint
                                            </a>
                                        </li>

                                        <li>
                                            <a
                                                href="#transcription-ack-request"
                                                class="link-body-emphasis d-inline-flex text-decoration-none rounded"
                                            >
                                                Request
                                            </a>
                                        </li>

                                        <li>
                                            <a
                                                href="#transcription-ack-response"
                                                class="link-body-emphasis d-inline-flex text-decoration-none rounded"
                                            >
                                                Response
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li class="border-top my-3"></li>
                        </ul>
                    </div>

                    <div
                        class="p-3 col scroll-container"
                        style={{
                            width: "100%",
                            maxHeight: "66vh",
                            overflowY: "overlay"
                        }}
                    >
                        {/* FAST TRANSCRIPTION */}

                        <div
                            class="col pb-3 mb-3 link-body-emphasis text-decoration-none border-bottom"
                            style={{ marginTop: "5rem" }}
                            id="fast-transcription-overview"
                        >
                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                The <strong>Audio Transcription API</strong> provides
                                a fast and reliable interface for converting short
                                audio clips (maximum 15 seconds) into text. It is
                                optimized for real-time applications where turnaround
                                time and transcription accuracy are critical.
                            </p>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                The API guarantees only valid and complete
                                transcription responses. Any errors (e.g.,
                                unsupported format, silent audio, or internal failure)
                                are filtered out or reported with clear error messages
                                — no partial or empty transcriptions are returned.
                            </p>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                The endpoint strictly enforces a maximum audio length
                                of 15 seconds to ensure optimal processing speed and
                                resource utilization. Submissions exceeding this limit
                                are rejected with appropriate validation messages.
                            </p>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                Built on a high-performance GPU backend, the system
                                delivers near-instantaneous transcription with a
                                consistent average latency of under 5 seconds. This
                                makes it ideal for voice assistants, live chat, and
                                other low-latency use cases.
                            </p>
                        </div>

                        <div
                            class="col pb-3 mb-3 link-body-emphasis text-decoration-none border-bottom"
                            id="fast-transcription-endpoint"
                        >
                            <p
                                class="fs-5"
                                style={{ textAlign: "justify" }}
                            >
                                Endpoint
                            </p>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                <code>
                                    <strong>POST</strong>{" "}
                                    https://api.decipherx.in/Transcribe/AudioTranscription/Fast
                                </code>
                            </p>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                <h6>
                                    Headers
                                    <small
                                        className="text-small"
                                        style={{ fontWeight: "normal" }}
                                    >
                                        {" "}
                                        (key:value)
                                    </small>
                                </h6>

                                <code>
                                    <ul>
                                        <li>X-Auth-Key: User's API Key</li>
                                        <li>
                                            X-Subscription-Key: Active Subscription Key
                                        </li><li>
                                            X-Request-ID: Unique request identifier (optinal, for tracking)
                                        </li>
                                        <li>Content-Type: multipart/form-data</li>
                                        <li>Accept: application/json</li>
                                    </ul>
                                </code>
                            </p>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                <h6>
                                    Request Body
                                    <small
                                        className="text-small"
                                        style={{ fontWeight: "normal" }}
                                    >
                                        {" "}
                                        (<code>multipart/form-data</code>)
                                    </small>
                                </h6>

                                <code>
                                    <ul>
                                        <li>audioWaveFile: WAV audio file stream</li>
                                        <li>
                                            language: Audio language code (e.g. "en")
                                        </li>
                                    </ul>
                                </code>
                            </p>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                <h6>cURL Command</h6>

                                <code>
                                    <pre>
                                        curl -X POST https://api.decipherx.in/Transcribe/AudioTranscription/Fast
                                        {"\n"}
                                        {"-H \"X-Auth-Key: xxx-x---xx--xxx--xx\""}
                                        {"\n"}
                                        {"-H \"X-Subscription-Key: x--x-x---xxx--xx\""}
                                        {"\n"}
                                        {"-H \"X-Request-ID: 550e8400-e29b-41d4-a716-446655440000\""}
                                        {"\n"}
                                        {"-H \"Content-Type: multipart/form-data\""}
                                        {"\n"}
                                        {"-d '{\"audioWaveFile\": obj_stream, \"language\": \"en\"}'"}
                                    </pre>
                                </code>
                            </p>
                        </div>

                        <div
                            class="col pb-3 mb-3 link-body-emphasis text-decoration-none border-bottom"
                            id="fast-transcription-response"
                        >
                            <p
                                class="fs-5"
                                style={{ textAlign: "justify" }}
                            >
                                Response
                            </p>

                            <pre>
                                <code>
                                    <JSONPretty
                                        id="json-pretty"
                                        theme={JSONPretty}
                                        data={JSON.stringify(
                                            {
                                                "StatusCode": 200,
                                                "Message": "Transcription successful",
                                                "TranscriptionData": {
                                                    "RequestReceivedAt": "2025-04-15T17:09:15.8721427+05:30",
                                                    "Transcription": " Small i, small v, small d, small x, capital A, 7.",
                                                    "TranscriptionDuration": 274.26,
                                                    "AudioFileReferenceName": "59d3f5c3088549a18292c3f14c30ac34.wav"
                                                }
                                            },
                                            undefined,
                                            2
                                        )}
                                    />
                                </code>
                            </pre>
                        </div>

                        <div
                            class="col pb-3 mb-3 link-body-emphasis text-decoration-none border-bottom"
                            id="fast-transcription-technicals"
                        >
                            <p
                                class="fs-5"
                                style={{ textAlign: "justify" }}
                            >
                                Technical Specifications
                            </p>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                <ul>
                                    <li>
                                        <span
                                            class="fs-6"
                                            style={{ fontWeight: "500" }}
                                        >
                                            Audio Format
                                        </span>
                                        : WAV, MP3, OGG
                                    </li>

                                    <li>
                                        <span
                                            class="fs-6"
                                            style={{ fontWeight: "500" }}
                                        >
                                            Audio Length
                                        </span>
                                        : Maximum 15 seconds
                                    </li>

                                    <li>
                                        <span
                                            class="fs-6"
                                            style={{ fontWeight: "500" }}
                                        >
                                            Audio Size
                                        </span>
                                        : Maximum 5 MB
                                    </li>

                                    <li>
                                        <span
                                            class="fs-6"
                                            style={{ fontWeight: "500" }}
                                        >
                                            Response Time
                                        </span>
                                        : Average under 5 seconds
                                    </li>

                                    <li>
                                        <span
                                            class="fs-6"
                                            style={{ fontWeight: "500" }}
                                        >
                                            Supported Languages
                                        </span>
                                        : English
                                    </li>

                                    <li>
                                        <span
                                            class="fs-6"
                                            style={{ fontWeight: "500" }}
                                        >
                                            Authentication
                                        </span>
                                        : API Keys required
                                    </li>

                                    <li>
                                        <span
                                            class="fs-6"
                                            style={{ fontWeight: "500" }}
                                        >
                                            Concurrency
                                        </span>
                                        : 300 requests per minute
                                    </li>
                                </ul>
                            </p>
                        </div>

                        <div
                            class="col pb-3 mb-3 link-body-emphasis text-decoration-none border-bottom"
                            id="fast-transcription-errors"
                        >
                            <p
                                class="fs-5"
                                style={{ textAlign: "justify" }}
                            >
                                Error Codes
                            </p>

                            <h6>HTTP Error Codes</h6>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                <ul>
                                    <li>
                                        <code>
                                            <span
                                                class="fs-6"
                                                style={{ fontWeight: "500" }}
                                            >
                                                400
                                            </span>{" "}
                                            Bad Request
                                        </code>
                                        {" "}
                                        - Invalid audio format or missing parameters
                                    </li>

                                    <li>
                                        <code>
                                            <span
                                                class="fs-6"
                                                style={{ fontWeight: "500" }}
                                            >
                                                401
                                            </span>{" "}
                                            Unauthorized
                                        </code>
                                        {" "}
                                        - User not found with provided X-Auth-Key header
                                    </li>

                                    <li>
                                        <code>
                                            <span
                                                class="fs-6"
                                                style={{ fontWeight: "500" }}
                                            >
                                                403
                                            </span>{" "}
                                            Forbidden
                                        </code>
                                        {" "}
                                        - Access denied to the requested resource
                                    </li>

                                    <li>
                                        <code>
                                            <span
                                                class="fs-6"
                                                style={{ fontWeight: "500" }}
                                            >
                                                404
                                            </span>{" "}
                                            Not Found
                                        </code>
                                        {" "}
                                        - Endpoint not found
                                    </li>

                                    <li>
                                        <code>
                                            <span
                                                class="fs-6"
                                                style={{ fontWeight: "500" }}
                                            >
                                                429
                                            </span>{" "}
                                            Too Many Requests
                                        </code>
                                        {" "}
                                        - Rate limit exceeded
                                    </li>

                                    <li>
                                        <code>
                                            <span
                                                class="fs-6"
                                                style={{ fontWeight: "500" }}
                                            >
                                                500
                                            </span>{" "}
                                            Internal Server Error
                                        </code>
                                        {" "}
                                        - An unexpected error occurred on the server
                                    </li>
                                </ul>
                            </p>

                            <h6>
                                Custom Error Codes
                                <small
                                    className="text-small"
                                    style={{ fontWeight: "normal" }}
                                >
                                    {" "}
                                    (In the api response body)
                                </small>
                            </h6>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                <ul>
                                    <li>
                                        <code>401 Unauthorized</code>
                                        {" "}
                                        - User not found with provided X-Auth-Key header
                                    </li>

                                    <li>
                                        <code>418 Subscription Expired</code>
                                    </li>

                                    <li>
                                        <code>
                                            419 Subscription credits exhausted
                                        </code>
                                    </li>

                                    <li>
                                        <code>420 Subscription not active</code>
                                    </li>

                                    <li>
                                        <code>404 Subscription not found</code>
                                        {" "}
                                        - Subscription not found with given
                                        X-Subscription-Key header
                                    </li>

                                    <li>
                                        <code>404 Technical error occurred</code>
                                    </li>
                                </ul>
                            </p>

                            <p
                                class="fs-5"
                                style={{ textAlign: "justify" }}
                            >
                                <h6>Example Error Response</h6>
                            </p>

                            <pre>
                                <code>
                                    <JSONPretty
                                        id="json-pretty"
                                        theme={JSONPretty}
                                        data={JSON.stringify(
                                            {
                                                StatusCode: 401,
                                                Message:
                                                    "X-Auth-Key or X-Subscription-Key header missing",
                                                TranscriptionData: {
                                                    RequestReceivedAt: null,
                                                    Transcription: null,
                                                    TranscriptionDuration: 0,
                                                    AudioFileReferenceName: null
                                                }
                                            },
                                            undefined,
                                            2
                                        )}
                                    />
                                </code>
                            </pre>
                        </div>

                        {/* ================================================= */}
                        {/* TRANSCRIPTION ACK DOCUMENTATION                   */}
                        {/* ================================================= */}

                        <div
                            class="col pb-3 mb-3 link-body-emphasis text-decoration-none border-bottom"
                            id="transcription-ack-overview"
                        >
                            <p
                                class="fs-5"
                                style={{ textAlign: "justify" }}
                            >
                                Transcription Acknowledgement (ACK)
                            </p>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                The <strong>Transcription ACK API</strong> is used
                                to acknowledge a transcription request after the
                                transcription response has been received and
                                processed by the client.
                            </p>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                The acknowledgement contains the original request
                                identifier <code>
                                    <strong>X-Request-ID</strong>
                                </code>, acknowledgement remarks, and the actual
                                transcription response being acknowledged.
                            </p>

                            <p>
                                <code>
                                    <strong>X-Request-ID</strong>
                                </code> is a unique identifier associated with the original transcription request. It is used to correlate the acknowledgement request with the corresponding transcription response.
                            </p>
                            <p>
                                The client may include <code><strong>X-Request-ID</strong></code> as an HTTP header when sending a transcription request to the <code>
                                    <strong> /AudioTranscription/Fast</strong></code> endpoint. The same <code><strong>X-Request-ID</strong></code> will be returned in the transcription response's as HTTP header.
                            </p>

                            <p>
                                When sending the acknowledgement request, the client must include this identifier to ensure that the acknowledgement is correctly associated with the original transcription request and can be properly tracked and validated.
                            </p>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                When the acknowledgement is registered successfully,
                                the API returns{" "}
                                <code>
                                    <strong>HTTP 200 OK</strong>
                                </code> only, no content.
                            </p>
                        </div>

                        <div
                            class="col pb-3 mb-3 link-body-emphasis text-decoration-none border-bottom"
                            id="transcription-ack-endpoint"
                        >
                            <p
                                class="fs-5"
                                style={{ textAlign: "justify" }}
                            >
                                Endpoint
                            </p>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                <code>
                                    <strong>POST</strong>{" "}
                                    https://api.decipherx.in/Transcribe/TranscriptionACK
                                </code>
                            </p>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                <h6>
                                    Headers
                                    <small
                                        className="text-small"
                                        style={{ fontWeight: "normal" }}
                                    >
                                        {" "}
                                        (key:value)
                                    </small>
                                </h6>

                                <code>
                                    <ul>
                                        <li>X-Auth-Key: User's API Key</li>

                                        <li>
                                            X-Subscription-Key: Active Subscription Key
                                        </li>

                                        <li>
                                            Content-Type: application/json
                                        </li>
                                    </ul>
                                </code>
                            </p>
                        </div>

                        <div
                            class="col pb-3 mb-3 link-body-emphasis text-decoration-none border-bottom"
                            id="transcription-ack-request"
                        >
                            <p
                                class="fs-5"
                                style={{ textAlign: "justify" }}
                            >
                                Request
                            </p>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                <h6>
                                    Request Body
                                    <small
                                        className="text-small"
                                        style={{ fontWeight: "normal" }}
                                    >
                                        {" "}
                                        (<code>application/json</code>)
                                    </small>
                                </h6>

                                <ul>
                                    <li>
                                        <code>X-Request-ID</code>: Unique request
                                        identifier associated with the transcription
                                        request.
                                    </li>

                                    <li>
                                        <code>ACKRemarks</code>: Acknowledgement
                                        remarks supplied by the client.
                                    </li>

                                    <li>
                                        <code>TranscriptionResponse</code>: The
                                        transcription response being acknowledged.
                                    </li>
                                </ul>
                            </p>

                            <h6>Example Request Body</h6>

                            <pre>
                                <code>
                                    <JSONPretty
                                        id="json-pretty"
                                        theme={JSONPretty}
                                        data={JSON.stringify(
                                            {
                                                "X-Request-ID":
                                                    "550e8400-e29b-41d4-a716-446655440000",

                                                ACKRemarks:
                                                    "Transcription received successfully",

                                                TranscriptionResponse: {
                                                    StatusCode: 200,

                                                    Message:
                                                        "Transcription successful",

                                                    TranscriptionData: {
                                                        RequestReceivedAt:
                                                            "2025-04-15T17:09:15.8721427+05:30",

                                                        Transcription:
                                                            " Small i, small v, small d, small x, capital A, 7.",

                                                        TranscriptionDuration: 274.26,

                                                        AudioFileReferenceName:
                                                            "59d3f5c3088549a18292c3f14c30ac34.wav"
                                                    }
                                                }
                                            },
                                            undefined,
                                            2
                                        )}
                                    />
                                </code>
                            </pre>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                <h6>cURL Command</h6>

                                <code>
                                    <pre>{`curl -X POST https://api.decipherx.in/Transcribe/TranscriptionACK \\
-H "X-Auth-Key: xxx-x---xx--xxx--xx" \\
-H "X-Subscription-Key: x--x-x---xxx--xx" \\
-H "Content-Type: application/json" \\
-H "Accept: application/json" \\
-d '{
  "X-Request-ID": "550e8400-e29b-41d4-a716-446655440000",
  "ACKRemarks": "Transcription received successfully",
  "TranscriptionResponse": {
    "StatusCode": 200,
    "Message": "Transcription successful",
    "TranscriptionData": {
      "RequestReceivedAt": "2025-04-15T17:09:15.8721427+05:30",
      "Transcription": " Small i, small v, small d, small x, capital A, 7.",
      "TranscriptionDuration": 274.26,
      "AudioFileReferenceName": "59d3f5c3088549a18292c3f14c30ac34.wav"
    }
  }
}'`}</pre>
                                </code>
                            </p>
                        </div>

                        <div
                            class="col pb-3 mb-3 link-body-emphasis text-decoration-none border-bottom"
                            id="transcription-ack-response"
                        >
                            <p
                                class="fs-5"
                                style={{ textAlign: "justify" }}
                            >
                                Response
                            </p>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                When the acknowledgement is successfully registered,
                                the endpoint returns:
                            </p>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                <code>
                                    <strong>HTTP 200 OK</strong>
                                </code>
                            </p>

                            <p
                                class="fs-6"
                                style={{ textAlign: "justify" }}
                            >
                                No JSON response body is returned.
                            </p>
                        </div>
                    </div>
                </main>
            </div>

            <div
                className="container py-3"
                style={{ maxHeight: "241px" }}
            >
                <Footer />
            </div>
        </>
    );
}

export default AudioTranscribeDocs;